/* lua.js generated code undefined */
 // 7日活跃标签配置
let config = table(
    [1, 0, table(
        [1, "type", "login"],
        [1, "min", 0],
        [1, "max", 0]
    )],
    [1, 1, table(
        [1, "type", "login"],
        [1, "min", 1],
        [1, "max", 1]
    )],
    [1, 2, table(
        [1, "type", "login"],
        [1, "min", 2],
        [1, "max", 2]
    )],
    [1, 3, table(
        [1, "type", "login"],
        [1, "min", 3],
        [1, "max", 3]
    )],
    [1, 4, table(
        [1, "type", "login"],
        [1, "min", 4],
        [1, "max", 4]
    )],
    [1, 5, table(
        [1, "type", "login"],
        [1, "min", 5],
        [1, "max", 5]
    )],
    [1, 6, table(
        [1, "type", "login"],
        [1, "min", 6],
        [1, "max", 6]
    )],
    [1, 7, table(
        [1, "type", "login"],
        [1, "min", 7],
        [1, "max", 7]
    )]
)
module.exports = config
